import React from 'react'
import { Images } from '../../../utils/imageConstants'
import type { Message } from '../types'

interface AIMessageProps {
  message: Message
  onCopy: (text: string) => void
}

const AIMessage: React.FC<AIMessageProps> = ({ message, onCopy }) => {
  return (
    <div className="statgpt-ai-message-wrapper">
      <div className="statgpt-ai-message-content">
        <div className="statgpt-ai-message-bubble">
          <div className="statgpt-ai-logo">
            <img src={Images.main_logo} alt="StatGPT" />
          </div>
          <div className="statgpt-ai-message-card">
            <p className="statgpt-ai-message-text">{message.text}</p>
          </div>
        </div>
        {message.status === 'completed' && (
          <div className="statgpt-ai-message-actions">
            <button
              className="statgpt-copy-icon-button"
              onClick={() => onCopy(message.text)}
              title="Copy answer"
            >
              <img src={Images.statgpt_copy_icon} alt="Copy" />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default AIMessage

